module.exports = __webpack_public_path__ + "img/Bullet_06_companion.c8f3de00.png";